import PropTypes from 'prop-types'

const FEATURE_BOOKING_TYPES = {
    ONETIME: 'ONETIME',
    RECURRING: 'RECURRING'
}

const FEATURE_CLASSES = {
    ACCESSORY: 'ACCESSORY',
    SERVICE: 'SERVICE',
    WF_FEATURE: 'WF_FEATURE',
    WF_FEATURE_EXT_DATA_SHARING: 'WF_FEATURE_EXT_DATA_SHARING'
}

/**
 * Bookable feature definition for the REST model with information on bookable features for contracts.
 *
 * @typedef {Object} BookableFeature
 * @property {boolean}          [bookableForAccount]         - Flag indicating if booking for account is allowed
 * @property {boolean}          [bookableForUnit]            - Flag indicating if booking for unit is allowed
 * @property {array<object>}    [defaultPrices]              - List of default prices
 * @property {array<string>}    [disallowedTariffServices]   - List of disallowed tariff services
 * @property {string}           [featureBookingType]         - The type of the feature
 * @property {string}           [featureClass]               - The class of the feature
 * @property {string}           [featureMetaDataId]          - Identifier of the related feature data record (WfFeatureMetaData)
 * @property {string}           [featureTypeId]              - The identifier of the feature type
 * @property {string}           [featureTypeName]            - The name of the feature type
 * @property {boolean}          [isActivationFee]            - Flag indicating if the feature is an activation fee
 * @property {boolean}          [isDiyReadOnly]              - Flag indicating if the feature is read-only (no booking, terminating, assigning)
 * @property {boolean}          [isPromoEnabled]             - Flag indicating if a promotion for this feature is enabled
 * @property {boolean}          [multipleBookingsAllowed]    - Flag indicating if multiple bookings are allowed
 * @property {string}           [name]                       - Name of the feature
 * @property {string}           [stringcode]                 - String code for the feature
 * @property {array<string>}    [supportedUnitTypes]         - List of all supported unit types
 */
export const bookableFeaturePropType = PropTypes.shape({
    bookableForAccount: PropTypes.bool,
    bookableForUnit: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    defaultPrices: PropTypes.arrayOf(PropTypes.object),
    disallowedTariffServices: PropTypes.arrayOf(PropTypes.string),
    featureBookingType: PropTypes.oneOf(Object.values(FEATURE_BOOKING_TYPES)),
    featureClass: PropTypes.oneOf(Object.values(FEATURE_CLASSES)),
    featureMetaDataId: PropTypes.string,
    featureTypeId: PropTypes.string,
    featureTypeName: PropTypes.string,
    isActivationFee: PropTypes.bool,
    isDiyReadOnly: PropTypes.bool,
    isPromoEnabled: PropTypes.bool,
    multipleBookingsAllowed: PropTypes.bool,
    name: PropTypes.string,
    stringcode: PropTypes.string,
    supportedUnitTypes: PropTypes.arrayOf(PropTypes.string)
})
